













































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { User } from '@/models/user';
import type { GlobalPMSubPhase } from '@/models/pmsubphase';

@Component({
    name: 'GlobalSubPhasesList',
})
export default class GlobalSubPhasesList extends Vue {
    private tableSettings = {
        openedDetailed: Array<number>(),
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
        perPage: 50,
    };

    @Prop() private globals: GlobalPMSubPhase[];
    @Prop() private searchQuery: string;
    @Prop() private isLoading: boolean;
    @Prop() private editMode: boolean;

    @Getter('account/userInfo') private userInfo: User;

    private rowClicked(row) {
        this.$emit('rowClicked', row);
    }
}
